// @flow

import styled from 'styled-components';
import Check from 'assets/icons/check.svg';
import Add from 'assets/icons/add.svg';
import ArrowForward from 'assets/icons/arrow-forward.svg';
import Button from 'components/shared/button';
import { SPACING_SMALL, SPACING_MEDIUM } from 'styles/spacing';
import { FONT_WEIGHT_400, FONT_WEIGHT_700 } from 'styles/font-weight';
import {
  CLARK_ACCENT_PRIMARY,
  CLARK_SECONDARY,
  GREY_25,
  GREY_50,
  GREY_75,
  WHITE,
} from 'styles/colors';
import { LINE_HEIGHT_COPY } from 'styles/line-height';
import { TYPE_SCALE_F6 } from 'styles/type-scale';
import { BORDER_WIDTH_1 } from 'styles/borders';
import media from 'styles/media-queries';

const BUTTON_HEIGHT = '3rem';

export const ClientName = styled.div`
  ${FONT_WEIGHT_400};
  ${LINE_HEIGHT_COPY};
`;

export const Details = styled.div`
  ${LINE_HEIGHT_COPY};
  padding-left: ${SPACING_MEDIUM};
`;

// $FlowFixMe
export const StyledCheck = styled<any>(Check)`
  height: calc(${SPACING_SMALL} + ${SPACING_MEDIUM});
  width: calc(${SPACING_SMALL} + ${SPACING_MEDIUM});
  color: ${CLARK_ACCENT_PRIMARY};

  ${media.small`
    margin: ${SPACING_MEDIUM};
  `};
`;

// $FlowFixMe
export const StyledAdd = styled<any>(Add)`
  color: ${GREY_50};
  height: calc(${SPACING_SMALL} + ${SPACING_MEDIUM});
  width: calc(${SPACING_SMALL} + ${SPACING_MEDIUM});
`;

export const StyledButton = styled<any>(Button)`
  ${TYPE_SCALE_F6};
  ${FONT_WEIGHT_700};
  background: ${WHITE};
  border: ${BORDER_WIDTH_1} solid ${GREY_25};
  color: ${GREY_75};
  height: ${BUTTON_HEIGHT};
  text-transform: uppercase;
  padding: 0;
  width: 100%;
  &:before {
    background: ${GREY_75};
  }
  &:hover {
    color: ${WHITE};
  }
`;

// $FlowFixMe
export const StyledArrow = styled<any>(ArrowForward)`
  color: ${CLARK_SECONDARY};
`;



// WEBPACK FOOTER //
// ./src/components/sessions/list/past/row/styles.js